<template>
<div class="category-tiles-home-block container-padded">
  <CategoryTiles v-if="isWideScreen"
                 :categories="categories"
                 :wide-categories="wideCategories"
  />
  <CategoryNestedTiles v-else :categories="categories" />
</div>
</template>

<script>
import { mapState } from 'vuex';
import findCategoryInTree from '@/helpers/findCategoryInTree';

export default {
  components: {
    CategoryNestedTiles: () => import('@/components/CategoryNestedTiles'),
    CategoryTiles: () => import('@/components/CategoryTiles'),
  },

  computed: {
    ...mapState({
      categogries_settings: state => state.settings.home_categories,
    }),

    categories() {
      if (this.categogries_settings.categories_to_display_select === 'all_root') {
        return this.$store.state.catalog.visibleCategoriesTree;
      }

      if (process.env.NODE_ENV !== 'production') {
        if (this.categogries_settings.categories_to_display_select !== 'from_list') {
          throw new Error('Unexpected display selection type');
        }
      }

      const list = [];

      for (const { category_id } of this.categogries_settings.categories_list) {
        const c = findCategoryInTree(this.$store.state.catalog.visibleCategoriesTree, category_id);

        if (!c) {
          console.error('Category not found');
          continue;
        }

        list.push(c);
      }

      return list;
    },

    wideCategories() {
      return this.categogries_settings.categories_list
        .filter(({ size }) => size === '2')
        .map(({ category_id }) => category_id);
    },

    isWideScreen() {
      return this.$store.getters['ui/isBreakpointActive']('sm');
    }
  }
}
</script>

<style lang="less">
.category-tiles-home-block {
  @apply my-6;
}
</style>
